(function () {
function $d5f992f8158b4022$export$21a5e8c01990eb73() {
    $("#main-navigation").removeClass("hidden");
    $("#hamburger .open").addClass("hidden");
    $("#hamburger .close").removeClass("hidden");
}
function $d5f992f8158b4022$export$c9e788aaf7edc9f8() {
    $("#main-navigation").addClass("hidden");
    $("#hamburger .close").addClass("hidden");
    $("#hamburger .open").removeClass("hidden");
}


function $410ec15519575c37$export$f52e29715bba3529(date) {
    var endTime = new Date(date);
    endTime = Date.parse(endTime) / 1000;
    var now = new Date();
    now = Date.parse(now) / 1000;
    var timeLeft = endTime - now;
    var days = Math.floor(timeLeft / 86400);
    var hours = Math.floor((timeLeft - days * 86400) / 3600);
    var minutes = Math.floor((timeLeft - days * 86400 - hours * 3600) / 60);
    // var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));
    if (hours < "10") hours = "0" + hours;
    if (minutes < "10") minutes = "0" + minutes;
    // if (seconds < "10") { seconds = "0" + seconds; }
    $("#days").html(days);
    $("#hours").html(hours);
    $("#minutes").html(minutes);
// $("#seconds").html(seconds);
}


// Stop transitions before page has loaded
$(window).on("load", function() {
    $("body").removeClass("preload");
});
// Toggle navigation
$("#hamburger").click(function(e) {
    e.preventDefault();
    $("#main-navigation").hasClass("hidden") ? (0, $d5f992f8158b4022$export$21a5e8c01990eb73)() : (0, $d5f992f8158b4022$export$c9e788aaf7edc9f8)();
});
// Reset if browser is resized
$(window).resize(function() {
    if ($(window).width() >= 900) (0, $d5f992f8158b4022$export$c9e788aaf7edc9f8)();
});
// Start countdown
setInterval(function() {
    (0, $410ec15519575c37$export$f52e29715bba3529)($("#countdown").data("time"));
}, 1000);
// Page scroll anchor links
var $089c40fcbb903d20$var$currentHash = "#";
var $089c40fcbb903d20$var$anchors = $(".anchor-target");
$(".anchor").click(function() {
    $(".anchor").removeClass("bg-blue");
    $(this).addClass("bg-blue");
});
$(document).scroll(function() {
    var currentTop = window.pageYOffset / 1 + 80;
    for(var i = 0; i < $089c40fcbb903d20$var$anchors.length; i++){
        var currentElementTop = $($089c40fcbb903d20$var$anchors[i]).offset().top;
        var hash = $($089c40fcbb903d20$var$anchors[i]).attr("id");
        if (currentElementTop < currentTop && currentTop < currentElementTop + $($089c40fcbb903d20$var$anchors[i]).height() && $089c40fcbb903d20$var$currentHash != hash) {
            if (history.pushState) history.pushState(null, null, "#" + hash);
            else location.hash = "#" + hash;
            $('a[href!="#' + hash + '"]').removeClass("bg-blue");
            $('a[href="#' + hash + '"]').addClass("bg-blue");
            $089c40fcbb903d20$var$currentHash = hash;
        }
    }
});

})();
//# sourceMappingURL=main.js.map
